var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.66668V4.00089C18.3333 2.8919 18.3333 2.33741 18.0997 1.99665C17.8956 1.69892 17.5795 1.49668 17.2237 1.43612C16.8164 1.36681 16.3129 1.59918 15.306 2.06391L3.47869 7.52267C2.58067 7.93714 2.13167 8.14437 1.80281 8.46577C1.51208 8.74991 1.29016 9.09675 1.15401 9.47979C1 9.91307 1 10.4076 1 11.3966V18M19 17.3333H19.0133M1 12.9333L1 21.7333C1 23.2268 1 23.9736 1.29065 24.544C1.54631 25.0458 1.95426 25.4537 2.45603 25.7094C3.02646 26 3.77319 26 5.26667 26H20.7333C22.2268 26 22.9735 26 23.544 25.7094C24.0457 25.4537 24.4537 25.0458 24.7094 24.544C25 23.9736 25 23.2268 25 21.7333V12.9334C25 11.4399 25 10.6931 24.7094 10.1227C24.4537 9.62094 24.0457 9.213 23.544 8.95733C22.9735 8.66668 22.2268 8.66668 20.7333 8.66668L5.26667 8.66668C3.77319 8.66668 3.02646 8.66668 2.45603 8.95733C1.95426 9.21299 1.54631 9.62094 1.29065 10.1227C1 10.6931 1 11.4399 1 12.9333ZM19.6667 17.3333C19.6667 17.7015 19.3682 18 19 18C18.6318 18 18.3333 17.7015 18.3333 17.3333C18.3333 16.9652 18.6318 16.6667 19 16.6667C19.3682 16.6667 19.6667 16.9652 19.6667 17.3333Z",
    stroke: "#6E56CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f1fd8dd6c379d8c515f1aae81ff30bdc.svg";
export { ForwardRef as ReactComponent };